export { Panels } from "@/panels/modules/panels/components/Panels";
